<!-- <section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section> -->
<tabset class="nav nav-tabs admin-tab">
    <tab class="dynamic-tab padding0" heading="New Tickets" (select)="selectTab(1)" [active]="activetab==1">
    </tab>
    <tab class="dynamic-tab padding0" heading="All Tickets" (select)="selectTab(2)" [active]="activetab==2">
    </tab>
    <tab class="dynamic-tab padding0" heading="Closed Tickets" (select)="selectTab(3)" [active]="activetab==3">
    </tab>
    <tab class="dynamic-tab padding0" heading="Spam Tickets" (select)="selectTab(4)" [active]="activetab==4">
    </tab>
</tabset>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/email-tickets.component.html